import getKey from '../lib/getKey.js';

class Tab {
    constructor(tabEle, panelEle) {
        this.tabEle = tabEle;
        this.panelEle = panelEle;
    }
}

class TabList {
    constructor(containerEle) {
        const tabListEle = containerEle.querySelector('[role=tablist]');

        const tabEles = [...tabListEle.querySelectorAll('[role=tab]')];
        this._tabs = tabEles.map(tabEle => {
            const id = tabEle.getAttribute('aria-controls');
            const panelEle = containerEle.querySelector(`[id="${id}"]`);
            const tab = new Tab(tabEle, panelEle);
            tabEle.addEventListener('click', event => {
                event.preventDefault();
                this._selectTab(tab);
            });
            return tab;
        });
        this._activeTab = this._tabs[0];

        tabListEle.addEventListener('keydown', event => {
            switch (getKey(event)) {
                case 'ArrowLeft':
                    this._selectPreviousTab();
                    break;

                case 'ArrowRight':
                    this._selectNextTab();
                    break;

                default:
                    return;
            }

            event.preventDefault();
            event.stopPropagation();
        });
    }

    _selectTab(tab) {
        this._tabs.forEach(tab => {
            tab.tabEle.classList.remove('newtab--active');
            tab.tabEle.tabIndex = -1;
            tab.tabEle.setAttribute('aria-selected', 'false');
            tab.panelEle.classList.add('hidden');
        });
        this._activeTab = tab;
        tab.tabEle.classList.add('newtab--active');
        tab.tabEle.tabIndex = 0;
        tab.tabEle.focus();
        tab.tabEle.setAttribute('aria-selected', 'true');
        tab.panelEle.classList.remove('hidden');
        tab.panelEle.tabIndex = 0;
    }

    _selectPreviousTab() {
        let index = this._tabs.indexOf(this._activeTab);
        if (index === -1 || index === 0) {
            index = this._tabs.length - 1;
        } else {
            index -= 1;
        }
        this._selectTab(this._tabs[index]);
    }

    _selectNextTab() {
        let index = this._tabs.indexOf(this._activeTab);
        if (index === -1 || index === this._tabs.length - 1) {
            index = 0;
        } else {
            index += 1;
        }
        this._selectTab(this._tabs[index]);
    }
}

export default {
    dependencies: ['$element'],
    callable(ele) {
        // eslint-disable-next-line
        new TabList(ele);
    },
};



// WEBPACK FOOTER //
// ./controllers/safetyElementTabs.js